import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('vskr-theme');
    return saved ? saved === 'dark' : false;
  });

  const [customization, setCustomization] = useState({
    primaryGradient: 'ocean',
    glassmorphism: 'medium',
    animationSpeed: 'normal',
    glowIntensity: 50,
    hoverEffects: true,
    depth3d: true,
  });

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    localStorage.setItem('vskr-theme', isDark ? 'dark' : 'light');
  }, [isDark]);

  const toggleTheme = () => setIsDark(!isDark);

  const updateCustomization = (key, value) => {
    setCustomization(prev => ({ ...prev, [key]: value }));
  };

  return (
    <ThemeContext.Provider value={{
      isDark,
      toggleTheme,
      customization,
      updateCustomization
    }}>
      {children}
    </ThemeContext.Provider>
  );
};
